import { useEffect, useRef, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

let _clientIdPromise = null;
function fetchClientId() {
  if (!_clientIdPromise) {
    _clientIdPromise = fetch(`${API_URL}/api/paypal/config`)
      .then(r => r.json())
      .then(d => d.clientId)
      .catch(() => null);
  }
  return _clientIdPromise;
}

function loadPayPalSDK(clientId) {
  return new Promise((resolve, reject) => {
    if (window.paypal) { resolve(); return; }
    const existing = document.getElementById('paypal-sdk-script');
    if (existing) { existing.addEventListener('load', resolve); return; }
    const s = document.createElement('script');
    s.id = 'paypal-sdk-script';
    s.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=USD&intent=capture`;
    s.onload = resolve;
    s.onerror = () => reject(new Error('Failed to load PayPal'));
    document.body.appendChild(s);
  });
}

export default function PayPalButton({ createOrder, onApprove, onError, disabled }) {
  const containerRef = useRef(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (disabled) return;
    let cancelled = false;
    (async () => {
      try {
        const clientId = await fetchClientId();
        if (!clientId) throw new Error('PayPal not configured');
        await loadPayPalSDK(clientId);
        if (cancelled || !containerRef.current) return;
        containerRef.current.innerHTML = '';
        window.paypal.Buttons({
          createOrder,
          onApprove,
          onError: (e) => { if (onError) onError(e); },
          style: { layout: 'vertical', color: 'blue', shape: 'rect', label: 'pay', height: 44 },
        }).render(containerRef.current);
        if (!cancelled) setLoading(false);
      } catch (e) {
        if (!cancelled) { setErr(e.message); setLoading(false); }
      }
    })();
    return () => { cancelled = true; };
  }, [disabled]); // eslint-disable-line react-hooks/exhaustive-deps

  if (err) return <p style={{ color: '#f87171', fontSize: '0.82rem', textAlign: 'center' }}>{err}</p>;
  return (
    <div style={{ position: 'relative', minHeight: 48 }}>
      {loading && (
        <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.85rem', padding: '12px 0' }}>
          Loading PayPal…
        </div>
      )}
      <div ref={containerRef} style={{ opacity: loading ? 0 : 1, transition: 'opacity 0.3s' }} />
    </div>
  );
}
